import React from "react";
import theme from "../../../theme/theme";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

export const InputBox = (props) => {
  /**
   * Common reusable Dialog Style
   * @author Isabel Sprengers
   * @version 1.0
   */
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth={props.dialogSize === "full" ? true : false}>
      <DialogTitle
        style={{
          backgroundColor:"#7500C0",
          color:'#FFFFFF',
          height:'30px',
          padding: '5px 10px'
        }}
      >
        {props.title}
      </DialogTitle>
      <DialogContent style={{ overflowY: "unset",width: props.width }}>
        {props.textContent ? (
          <DialogContentText style={{ fontSize:'.9em', color: "#666666", fontWeight: "400"}}>{props.textContent}</DialogContentText>
        ) : (
          <div></div>
        )}
      </DialogContent>
      {props.dialogContent}
      {props.dialogActions}
    </Dialog>
  );
};

